module.exports = __webpack_public_path__ + "static/img/weibind.a76f3021.png";